import {
	Component,
	effect,
	input,
	output,
	untracked,
	viewChild,
} from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

import { SheetModule } from '@valk-nx/components/ui-sheet/src';
import { SheetComponent } from '@valk-nx/components/ui-sheet/src/lib/sheet';
import { SVG_ICON_IMPORTS } from '@valk-nx/helpers/lib/svg-unique-ids/svg-unique-ids.directive';

@Component({
	selector: `vp-filter-sheet-button`,
	templateUrl: './filter-sheet-button.html',
	imports: [SVG_ICON_IMPORTS, SheetModule, TranslatePipe],
})
export class FilterSheetButtonComponent {
	private static instanceCount = 0;
	private readonly instanceId = FilterSheetButtonComponent.instanceCount++;
	readonly triggerId = `filter-sheet-trigger-${this.instanceId}`;

	label = input.required<string>();
	openable = input<boolean>(false);
	iconLeading = input<string | undefined>(undefined);
	indicator = input<number | undefined>(undefined);
	numberOfResults = input<number | undefined>(undefined);

	/** Leave unset to let the trigger button open and close the sheet on its own. */
	open = input<boolean>();

	filterClick = output();
	opened = output();
	closed = output();

	private readonly sheet = viewChild(SheetComponent);

	constructor() {
		effect(() => {
			const open = this.open();
			const sheet = this.sheet();
			if (open === undefined || !sheet) return;

			untracked(() => {
				if (open && !sheet.showSheet()) {
					sheet.show();
				} else if (!open && sheet.showSheet()) {
					sheet.hide();
				}
			});
		});
	}

	handleClick() {
		if (!this.openable()) {
			this.filterClick.emit();
		} else if (!this.sheet()?.showSheet()) {
			this.opened.emit();
		}
	}
}
